
enum SESSION_ACTION {
  UNSUPPORTED = "UNSUPPORTED",
  LOGIN = "LOGIN",
  LOGOUT = "LOGOUT"
}

const seessionActionList = Object.values(SESSION_ACTION)

export default SESSION_ACTION
export {
  seessionActionList
}
